import {
  registerDatePicker,
  requestClose,
  unregisterDatePicker,
} from "./date_picker_manager";

export function registerManagedDatePicker({ key, pickerRef }) {
  registerDatePicker(key, {
    close: () => {
      if (pickerRef.current && pickerRef.current.setOpen) pickerRef.current.setOpen(false);
    },
    open: () => {
      if (pickerRef.current && pickerRef.current.setOpen) pickerRef.current.setOpen(true);
    },
    focus: () => {
      if (pickerRef.current && pickerRef.current.setFocus) pickerRef.current.setFocus();
    },
  });

  return () => unregisterDatePicker(key);
}

export function closeAndRefocusPicker({ key, pickerRef, setSkipNextOpen }) {
  if (setSkipNextOpen) setSkipNextOpen(true);
  requestClose(key);
  window.requestAnimationFrame(() => {
    if (pickerRef.current && pickerRef.current.setFocus) pickerRef.current.setFocus();
  });
}

